import { Header } from '../../../components/Header/index';
import { TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import GenericPromises from '../../../api/GenericPromises';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { FormsErrors } from '../../../hooks/Forms/FormsErrors';
import { ButtonStyled, PrimaryButton } from '../../../theme/buttons';
import { useTranslation } from 'react-i18next';
import { ItemFamily } from '../../../interfaces/Commons/Items/items';
import useSnackBar from '../../../components/Commons/SnackBar/useSnackBar';

export const AddItemFamilies = () => {
  const [t] = useTranslation("global");
  const navigate = useNavigate();
  const { GenericPostResource, GenericGetResourceGeneric } = GenericPromises();
  const { showSnackBar, SnackbarComponent } = useSnackBar();
  const { GetError } = FormsErrors();
  const [loadingPost, setLoadingPost] = useState(false);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<ItemFamily>({
    defaultValues: {
      item_family_name: "",
      item_family_code: "",
      item_family_description: undefined
    }
  });
  const onSubmit: SubmitHandler<ItemFamily> = (data) => onPost(data);

  const onPost = (data: ItemFamily) => {
    let myData = {
      item_family_name: data.item_family_name,
      item_family_description: data.item_family_description ?? null,
      item_family_code: data.item_family_code,
    }
    setLoadingPost(true);
    GenericPostResource("/itemfamilies", myData)
      .then((response) => {
        navigate("/itemfamilies", { state: { method: "add" } });
      })
      .catch((error) => {
        setLoadingPost(false);
        showSnackBar(error.message, 'error');
      });
  }

  const onCancel = () => {
    // validacion si quiere cancelar sus cambios 
    navigate("/itemfamilies", { state: {} });
  }

  useEffect(() => {
    GenericGetResourceGeneric("/companies", "/gcompanies").then((response) => {
      document.title = `${response.data.data[0].comercial_name} - ${t("item-families.title")}`;
    })
  }, [])

  return (
    <>
      <Header title={t("item-families.title-view")} />

      <div className='d-flex justify-content-center'>

        <div className='custom-card-view w-50'>

          <form onSubmit={handleSubmit(onSubmit)} className='mt-4'>

            <div className="custom-card-row">
              <Controller
                name="item_family_name"
                control={control}
                rules={{ required: true, maxLength: 150 }}
                render={({ field }) =>
                  <TextField
                    variant="filled"
                    ref={field.ref}
                    value={field.value}
                    onChange={(event) => { field.onChange(event.target.value) }}
                    label={t("item-families.fields.item_family_name")}
                    error={!!errors.item_family_name}
                    helperText={GetError(errors.item_family_name?.type)}
                    size="small"
                    style={{ width: "100%" }}
                  />
                }
              />
            </div>

            <div className="custom-card-row">
              <Controller
                name="item_family_code"
                control={control}
                rules={{ required: true, maxLength: 10 }}
                render={({ field }) =>
                  <TextField
                    variant="filled"
                    ref={field.ref}
                    value={field.value}
                    onChange={(event) => { field.onChange(event.target.value) }}
                    label={t("item-families.fields.item_family_code")}
                    error={!!errors.item_family_code}
                    helperText={GetError(errors.item_family_code?.type)}
                    size="small"
                    style={{ width: "100%" }}
                  />
                }
              />
            </div>

            <div className="custom-card-row">
              <Controller
                name="item_family_description"
                control={control}
                rules={{ maxLength: 300 }}
                render={({ field }) =>
                  <TextField
                    variant="filled"
                    ref={field.ref}
                    value={field.value}
                    onChange={(event) => { field.onChange(event.target.value) }}
                    label={t("item-families.fields.item_family_description")}
                    error={!!errors.item_family_description}
                    helperText={GetError(errors.item_family_description?.type)}
                    size="small"
                    style={{ width: "100%" }}
                  />
                }
              />
            </div>

            <div className='d-flex flex-row-reverse mt-4'>
              <PrimaryButton type='submit' variant='outlined' className='m-1' disabled={loadingPost}>{t("generic.buttons.accept")}</PrimaryButton>
              <ButtonStyled variant='contained' className='m-1' onClick={onCancel}>{t("generic.buttons.cancel")}</ButtonStyled>
            </div>

          </form>

        </div>
      </div>
      <SnackbarComponent />
    </>
  )
}
